import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { PAGES_URLS } from '../../../../lib/constants/routes';

function AntraegeInForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<EditIcon />} title={'Anträge in Förderung'}>
				<MeinBereichButton
					buttonName='Anträge in Förderung ansehen'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									items: [
										{
											field: 'Antragstatus_Antragstatus',
											operator: 'is',
											value: 'in Förderung',
										},
									],
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					buttonName='Mittelabruf durchführen'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									items: [
										{
											field: 'Antragstatus_Antragstatus',
											operator: 'is',
											value: 'in Förderung',
										},
									],
								},
							},
						});
					}}
				/>
				<MeinBereichButton
					buttonName='Verwendungsnachweis einreichen'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									items: [
										{
											field: 'Antragstatus_Antragstatus',
											operator: 'is',
											value: 'in Förderung',
										},
									],
								},
							},
						});
					}}
				/>
			</MeinBereichPaper>
		</>
	);
}

export default AntraegeInForderung;
